import { createReducer } from "@reduxjs/toolkit";

const initialState = {
  categories: [],
  productsByCategory: {
    products: [],
    isLoading: false,
    error: null,
  },
  isLoading: false,
  success: false,
  error: null,
};

export const categoryReducer = createReducer(initialState, (builder) => {
  builder
    .addCase("categoriesRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("categoriesSuccess", (state, action) => {
      state.isLoading = false;
      state.categories = action.payload;
    })
    .addCase("categoriesFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("createCategoryRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("createCategorySuccess", (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.categories.push(action.payload);
    })
    .addCase("createCategoryFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("updateCategoryRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("updateCategorySuccess", (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.categories = state.categories.map((category) =>
        category._id === action.payload._id ? action.payload : category
      );
    })
    .addCase("updateCategoryFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("deleteCategoryRequest", (state) => {
      state.isLoading = true;
    })
    .addCase("deleteCategorySuccess", (state, action) => {
      state.isLoading = false;
      state.categories = state.categories.filter(
        (category) => category._id !== action.payload
      );
    })
    .addCase("deleteCategoryFail", (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    })
    .addCase("productsByCategoryRequest", (state) => {
      state.productsByCategory.isLoading = true;
      state.productsByCategory.error = null;
    })
    .addCase("productsByCategorySuccess", (state, action) => {
      state.productsByCategory.isLoading = false;
      state.productsByCategory.products = action.payload;
    })
    .addCase("productsByCategoryFail", (state, action) => {
      state.productsByCategory.isLoading = false;
      state.productsByCategory.error = action.payload;
    })
    .addCase("clearErrors", (state) => {
      state.error = null;
    });
});